import React from 'react'
import PropTypes from 'prop-types'
import { SanitizeHTML } from '@tc-packages/tc-common'

export default function FAQSection({ section }) {
  const { items, node_id } = section

  return (
    <section className="faqSection" key={node_id}>
      <div className="container contentWrapper_large">
        <div className="accordion" id="accordion">
          {items.map((item) => {
            return (
              <div className="accordion_item" key={item.index}>
                <h4 className="accordion_header">
                  <button
                    aria-controls={`collapse${item.index}`}
                    aria-expanded="false"
                    className="accordion_button"
                    data-bs-target={`#collapse${item.index}`}
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    <SanitizeHTML html={item.question} />
                  </button>
                </h4>
                <div
                  aria-labelledby={`heading${item.index}`}
                  className="accordion_collapse collapse"
                  data-bs-parent="#accordion"
                  id={`collapse${item.index}`}
                >
                  <div className="accordion_body">
                    <SanitizeHTML html={item.answer} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

FAQSection.propTypes = {
  section: PropTypes.shape({
    items: PropTypes.array.isRequired,
    node_id: PropTypes.string.isRequired,
  }).isRequired,
}
